document.addEventListener('DOMContentLoaded', function (e) {
	const as_menu = document.querySelector('.m-navigation.menu--anti-semitism-menu');

	if (as_menu) {
		const parentLinks = as_menu.querySelectorAll('.menu-item--expanded');

		const expandChildList = function (link) {
			if (!link.classList.contains('open')) {
				link.classList.add('open');
				link.setAttribute('aria-expanded', 'true');
			} else {
				link.classList.remove('open');
				link.setAttribute('aria-expanded', 'false');
			}
			
			let linkSiblings = link.parentElement.childNodes;
			linkSiblings.forEach(sibling => {
				if (link !== sibling && sibling.classList) {
					if (sibling.classList.contains('open')) {
						sibling.classList.remove('open');
						sibling.querySelector('.m-menu--inner').removeAttribute('style');
					}
				}
			});

			let childMenu = link.querySelector('.m-menu--inner');
			if (childMenu.offsetHeight > 2 || !link.classList.contains('open')) {
				childMenu.removeAttribute('style');
			} else {
				childMenu.style.height = childMenu.scrollHeight + 10 + 'px';
			}
			return false;
		};

		parentLinks.forEach(function (link) {
			let span = link.querySelector('span');
			span.addEventListener('click', function (e) {
				e.preventDefault();
				expandChildList(link);
			});
			span.addEventListener('keydown', function (e) {
				if (e.code === 13) {
					e.preventDefault();
					expandChildList(link);
				}
			});
		});
	}
});
